// extracted by mini-css-extract-plugin
export default {"PromoCodeImage":"_1STFq","PromoCodeImageLogo":"_30yzh"};